import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import type DisableToggleTagDto from "./dto/disable-toggle-tag.dto";
import type DeleteTagDto from "./dto/delete-tag.dto";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";

export const TagsEffectActions = {
  disableToggleTag: `${Entities.Tags}_disableToggleTag`,
  deleteTag: `${Entities.Tags}_deleteTag`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.Tags,
  initSchema,
  aliasName: DIContainerKeys.TagsService,
})
export class TagsService extends HttpService {
  @loader(Loaders.DisableToggleTagLoader)
  @flagger(Flaggers.DisableToggleTagModalFlagger)
  @action(DIContainerKeys.TagsService)
  public *disableToggleTag(dto: DisableToggleTagDto): Generator<any, void, any> {
    
  }

  @loader(Loaders.DeleteTagLoader)
  @flagger(Flaggers.DeleteTagModalFlagger)
  @action(DIContainerKeys.TagsService)
  public *deleteTag(dto: DeleteTagDto): Generator<any, void, any> {
    
  }
}

